import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import weekOfYear from "dayjs/plugin/weekOfYear";

import { WeekData, CalendarConfig } from "src/services/config";

import mockCalendar from './date/mock-calendar.json';
import { FrequencyType, FrequencyTypeToReport, FrequencyTypeToObjective } from "../types/common";
import {
  getPreviousOccurrence,
  getYearAndSequenceMap,
  getDateFromYearAndSequenceMap,
} from "./date";

dayjs.extend(weekOfYear);
dayjs.extend(isoWeek);

// 导出所有从common.ts中导入的映射
export { FrequencyTypeToReport, FrequencyTypeToObjective };

// 导出兼容性对象映射
export const getDateFromYearAndSequence = getDateFromYearAndSequenceMap;
export const getYearAndSequence = getYearAndSequenceMap;

// 导出函数
export { getPreviousOccurrence };

/**
 * 根据频率类型格式化日期
 * @param startYear 开始年份
 * @param sequence 序列号
 * @param frequency 频率类型
 * @param isDetail 是否显示详细信息，为true时添加"期"字
 * @param calendarConfig 日历配置（可选，用于weekly类型）
 * @returns 格式化后的日期字符串
 */
export const formatDateByFrequency = (
  startYear: number, 
  sequence: number, 
  frequency: FrequencyType | string, 
  isDetail?: boolean,
  calendarConfig?: CalendarConfig | null
): string => {
  // 使用类型检查和类型转换确保frequency符合枚举类型
  const freqType = frequency as FrequencyType;
  const calendar:CalendarConfig = calendarConfig ||mockCalendar;
  // 处理特殊情况，当频率类型不是有效的枚举值时提供后备方案
  if (!getDateFromYearAndSequenceMap[freqType]) {
    return `${startYear}年 第${sequence}${isDetail ? '期' : ''}`;
  }
  
  try {
    // 获取日期对象
   switch (frequency) {
       case FrequencyType.Yearly:
         return `${startYear}年`;
       case FrequencyType.Quarterly: {
         return `${startYear}年第${sequence}季度`;
       }
       case FrequencyType.Monthly:
         return `${startYear}年${sequence}月`;
       case FrequencyType.Weekly: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const weekDataList = (calendar as any )[startYear.toString()] as WeekData[];
         const weekData = weekDataList.find(n=>n.sequence === sequence)
         return `${startYear}年${Number(weekData?.startDate?.split('-')[1]||0)}月第${weekData?.weeklySequence || 0}周`;
       }
       default:
         return "";
     }
  } catch (error) {
          // 错误处理
    return `${startYear}年 第${sequence}${isDetail ? '期' : ''}`;
  }
};
